import { NGText } from 'src/styles/theme/components/NGText/NGText';
import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { mq } from 'src/styles/theme/utils/functions';
import styled from 'styled-components';

export const StyledLabel = styled.label`
	display: block;
	min-height: 55px;
	user-select: none;

	margin-top: -8px;
	margin-left: 45px;

	width: calc(100% - 45px);

	${mq(EMediaQuery.md, 'min-height: 65px;')}
`;

export const NGTextEx = styled(NGText)`
	position: absolute;
	pointer-events: none;
`;
